"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[165],{

/***/ 6014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ JobGroupPath; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/FolderOpenOutlined.js
var FolderOpenOutlined = __webpack_require__(99800);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/RoundBadge/index.tsx + 1 modules
var RoundBadge = __webpack_require__(34583);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/theme.ts
var theme = __webpack_require__(32657);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var styles = __webpack_require__(93430);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Tooltip/index.tsx + 1 modules
var Tooltip = __webpack_require__(77435);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
// EXTERNAL MODULE: ../../node_modules/antd/es/col/index.js
var col = __webpack_require__(3086);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/client/JobGroupPath/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      & .ant-typography,\n      & svg {\n        color: ",
        "!important;\n      }\n\n      & .round-badge {\n        background: ",
        "!important;\n      }\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 12px;\n  gap: 12px;\n  align-items: center;\n  flex: 1;\n  overflow: auto;\n\n  ",
        "\n\n  flex-wrap: nowrap;\n\n  & .ant-col {\n    display: flex;\n    align-items: center;\n    overflow: auto;\n\n    > span {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  & svg {\n    font-size: 14px;\n    margin-right: 6px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const JobNameRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(_templateObject1(), (param)=>{
    let { $isDeleted , theme  } = param;
    return $isDeleted && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.colors.grey30, theme.colors.grey30);
});
const JobNameCol = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z)(_templateObject2(), (param)=>{
    let { $color  } = param;
    return $color && "color: ".concat($color, ";");
}, (param)=>{
    let { $maxWidth  } = param;
    return $maxWidth && "max-width: ".concat($maxWidth, "px;");
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/client/JobGroupPath/index.tsx





const JobGroupPath = (param)=>{
    let { name , path , showFullPath , isDeleted , ...props } = param;
    const renderIcon = ()=>{
        if (props.isJob) {
            return props.enabled && !isDeleted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundBadge/* RoundBadge */.J, {
                className: "round-badge",
                color: theme/* theme.colors.green40 */.r.colors.green40,
                size: 14,
                $marginRight: 8
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundBadge/* RoundBadge */.J, {
                className: "round-badge",
                color: theme/* theme.colors.grey40 */.r.colors.grey40,
                size: 14,
                $marginRight: 8
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FolderOpenOutlined/* default */.Z, {});
    };
    const renderPrefix = ()=>{
        const pathParts = path.split("/").slice(1, -1);
        if (!showFullPath || pathParts.length === 1) return;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobNameCol, {
                    $maxWidth: 104,
                    $color: theme/* theme.colors.grey50 */.r.colors.grey50,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FolderOpenOutlined/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Text */.xv, {
                            $color: theme/* theme.colors.grey50 */.r.colors.grey50,
                            children: pathParts[0]
                        })
                    ]
                }),
                pathParts.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobNameCol, {
                    $color: theme/* theme.colors.grey50 */.r.colors.grey50,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        title: pathParts.join(" / "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Text */.xv, {
                            $color: theme/* theme.colors.grey50 */.r.colors.grey50,
                            children: [
                                "/",
                                pathParts.length > 2 && " ... /"
                            ]
                        })
                    })
                })
            ]
        });
    };
    const jobName = /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobNameCol, {
        children: [
            renderIcon(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Text */.xv, {
                children: [
                    name,
                    isDeleted ? " (deleted)" : ""
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobNameRow, {
        $isDeleted: isDeleted,
        children: [
            renderPrefix(),
            jobName
        ]
    });
};


/***/ }),

/***/ 34583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ RoundBadge_RoundBadge; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/RoundBadge/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: none;\n  height: ",
        "px;\n  width: ",
        "px;\n  border-radius: ",
        "px;\n  background-color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const RoundBadge = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), (param)=>{
    let { $size  } = param;
    return $size;
}, (param)=>{
    let { $size  } = param;
    return $size;
}, (param)=>{
    let { $size  } = param;
    return Math.ceil($size / 2);
}, (param)=>{
    let { $color  } = param;
    return $color;
}, (param)=>{
    let { $marginRight  } = param;
    return $marginRight && "margin-right: ".concat($marginRight, "px;");
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/RoundBadge/index.tsx



const RoundBadge_RoundBadge = (param)=>{
    let { color , size , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundBadge, {
        ...props,
        $color: color,
        $size: size
    });
};


/***/ }),

/***/ 87803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ StatBadge_StatBadge; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/antd/es/tag/index.js + 1 modules
var tag = __webpack_require__(61382);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/StatBadge/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      cursor: pointer;\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: inline-flex;\n  align-items: center;\n  color: ",
        ";\n  border: none;\n  background: ",
        ";\n  min-width: 20px;\n  ",
        "\n  text-align: center;\n  font-weight: 600;\n\n  -webkit-print-color-adjust: exact;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const StatBadge = (0,styled_components_browser_esm/* default */.ZP)(tag/* default */.Z)(_templateObject1(), (param)=>{
    let { $clickable  } = param;
    return $clickable && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { $backgroundColor  } = param;
    return $backgroundColor;
}, (param)=>{
    let { $height  } = param;
    return $height && "height: ".concat($height, "px;");
});

// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/theme.ts
var theme = __webpack_require__(32657);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/StatBadge/index.tsx




const StatBadge_StatBadge = (param)=>{
    let { text , clickable =false , backgroundColor =theme/* theme.colors.green40 */.r.colors.green40 , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatBadge, {
        $clickable: clickable,
        $backgroundColor: backgroundColor,
        ...props,
        children: text
    });
};


/***/ }),

/***/ 78623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ Table; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/antd/es/config-provider/index.js + 6 modules
var config_provider = __webpack_require__(53486);
// EXTERNAL MODULE: ../../node_modules/antd/es/table/index.js + 109 modules
var table = __webpack_require__(74103);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(64368);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/theme.ts
var theme = __webpack_require__(32657);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../node_modules/antd/es/empty/index.js + 2 modules
var empty = __webpack_require__(18020);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var styles = __webpack_require__(93430);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Empty/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 22px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 64px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}



const Wrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
const Empty = (0,styled_components_browser_esm/* default */.ZP)(empty/* default */.Z)(_templateObject1());
const Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());
const Label = (0,styled_components_browser_esm/* default */.ZP)(styles/* Text */.xv)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey40;
});
const Image = styled_components_browser_esm/* default.img */.ZP.img(_templateObject4());

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Empty/index.tsx



const Empty_Empty = (props)=>{
    return /*#__PURE__*/ _jsx(S.Wrap, {
        children: /*#__PURE__*/ _jsx(S.Empty, {
            ...props
        })
    });
};
const NoData = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                src: "/images/empty.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: "No data"
            })
        ]
    });
const NoResults = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                src: "/images/eyes.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: "Oops! We have not found any results for your search query."
            })
        ]
    });

// EXTERNAL MODULE: ../../node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(48562);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Table/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  gap: ",
        ";\n  flex-direction: column;\n\n  & .ant-table-tbody > tr > td,\n  & .ant-table-thead > tr > th {\n    border-color: ",
        ";\n  }\n\n  & .ant-table-wrapper {\n    width: 100%;\n\n    & .ant-table-thead > tr > th::before {\n      content: none !important;\n    }\n    & .ant-table-thead > tr > th {\n      font-weight: 600;\n    }\n\n    .ant-table-row:hover > td,\n    .ant-table-cell-row-hover {\n      background: ",
        ";\n    }\n\n    .ant-table-row-level-0 {\n      position: relative;\n    }\n\n    button {\n      z-index: 777;\n    }\n\n    .ant-select {\n      z-index: 777;\n    }\n\n    .ant-table-cell-fix-left {\n      z-index: 778;\n    }\n\n    .ant-table-placeholder .table-cell-content {\n      width: 100% !important;\n      font-size: 15px;\n      font-weight: 400;\n    }\n\n    & .table-cell-content {\n      width: 100% !important;\n      font-size: 15px;\n      font-weight: 400;\n    }\n\n    // Extra line above first visible table row\n    // Usefull when we do not show table header\n    .ant-table-row:nth-of-type(2) > td {\n      border-top: 1px solid ",
        ";\n    }\n\n    .ant-table-tbody > tr > td {\n      padding: ",
        ";\n    }\n\n    .ant-table-tbody > tr > td a.table-cell-link {\n      padding: 16px 16px;\n      display: table-cell;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 53px;\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  height: 60vh;\n  .ant-skeleton-title {\n    height: ",
        "px;\n    border-radius: ",
        ";\n    display: flex;\n    flex: 1;\n    margin-top: 0;\n  }\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const styles_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject(), (param)=>{
    let { $gap  } = param;
    return typeof $gap === "number" ? "".concat($gap, "px") : "24px";
}, (param)=>{
    let { theme  } = param;
    return theme.colors.grey20;
}, (param)=>{
    let { theme , $disableHoverAnimation  } = param;
    return $disableHoverAnimation ? "none" : theme.colors.yellow10;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.grey10;
}, (param)=>{
    let { $rowPadding  } = param;
    return typeof $rowPadding === "number" ? "".concat($rowPadding, "px ").concat($rowPadding, "px") : undefined;
});
const Placeholder = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject1());
const PlaceholderSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default */.Z).attrs({
    title: true,
    paragraph: false,
    active: true
})(styles_templateObject2(), (param)=>{
    let { isHeader  } = param;
    return isHeader ? 54 : 1;
}, (param)=>{
    let { isHeader  } = param;
    return isHeader ? "12px 12px 0 0" : 0;
});

;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Table/index.tsx







const Table_Placeholder = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Placeholder, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderSkeleton, {
                isHeader: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderSkeleton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderSkeleton, {})
        ]
    });
const LinkContext = /*#__PURE__*/ (0,react.createContext)(null);
const Table = /*#__PURE__*/ (0,react.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-types
function(param, ref) {
    let { disableHoverAnimation , pageCardRef , columns , dataSource , loading , networkStatus , hasActiveFilters , header , headerGap , rowPadding , pagination , getRowLink , onRowClick , forbidExpand , empty , ...props } = param;
    const tableRef = (0,react.useRef)(null);
    const rowsRef = (0,react.useRef)({});
    const [previousLoadedDataSource, setPreviousLoadedDataSource] = (0,react.useState)(dataSource);
    const isInitialLoading = networkStatus === core_networkStatus/* NetworkStatus.loading */.I.loading;
    const isSubsequentLoading = networkStatus && networkStatus < core_networkStatus/* NetworkStatus.poll */.I.poll && !isInitialLoading;
    (0,react.useEffect)(()=>{
        if (!isInitialLoading && !isSubsequentLoading) setPreviousLoadedDataSource(dataSource);
    }, [
        dataSource,
        isInitialLoading,
        isSubsequentLoading
    ]);
    (0,react.useImperativeHandle)(ref, ()=>({
            focusSelectedRow: (rowKey)=>{
                setTimeout(()=>{
                    const row = rowsRef.current[rowKey];
                    if (row) {
                        row.scrollIntoView({
                            block: "center",
                            inline: "nearest"
                        });
                        row.animate({
                            backgroundColor: [
                                theme/* theme.colors.yellow20 */.r.colors.yellow20,
                                theme/* theme.colors.white */.r.colors.white
                            ]
                        }, 10000);
                    }
                }, 0);
            }
        }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(config_provider/* default */.ZP, {
        renderEmpty: empty ? empty : hasActiveFilters ? NoResults : NoData,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
            $disableHoverAnimation: disableHoverAnimation,
            $gap: headerGap,
            $rowPadding: rowPadding,
            children: [
                header,
                loading || isInitialLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_Placeholder, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default */.Z, {
                    rowKey: "id",
                    ref: tableRef,
                    columns: columns,
                    dataSource: !(dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) && isSubsequentLoading ? previousLoadedDataSource : dataSource,
                    loading: isSubsequentLoading,
                    pagination: pagination,
                    onChange: (_, __, ___, extra)=>{
                        if (extra.action === "paginate") {
                            if (pageCardRef) pageCardRef.scrollToTop();
                        }
                    },
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onRow: (args)=>{
                        return {
                            onClick: (e)=>{
                                const selectDropdownClassNames = [
                                    "ant-select-item-option-content",
                                    "ant-select-selection-item"
                                ];
                                if (typeof e.target.className === "string" && !e.target.className.split(" ").some((className)=>selectDropdownClassNames.includes(className))) onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(args === null || args === void 0 ? void 0 : args.id);
                            }
                        };
                    },
                    components: {
                        body: {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            row: (rowProps)=>{
                                var ref;
                                const record = (ref = rowProps.children[0]) === null || ref === void 0 ? void 0 : ref.props.record;
                                const id = record === null || record === void 0 ? void 0 : record.id;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkContext.Provider, {
                                    value: (()=>{
                                        if (typeof getRowLink === "function") return getRowLink(record) || null;
                                        return null;
                                    })(),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                        ...rowProps,
                                        ref: (el)=>id && (rowsRef.current[id] = el)
                                    })
                                });
                            },
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            cell: (cellProps)=>{
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                const link = (0,react.useContext)(LinkContext);
                                const { children , ...restCellProps } = cellProps;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                    ...restCellProps,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell-content",
                                            children: children
                                        }),
                                        link && (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "table-cell-link",
                                            href: link,
                                            children: " "
                                        }) : null
                                    ]
                                });
                            }
                        }
                    },
                    ...forbidExpand ? {
                        // hack because of antd bug - not allowing to disable expand icon when "children" prop is present
                        expandable: {
                            childrenColumnName: "non_existing"
                        }
                    } : {},
                    ...props
                })
            ]
        })
    });
});


/***/ }),

/***/ 77435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Tooltip; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Tooltip/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background-color: transparent;\n  color: ",
        ";\n  font-weight: 300;\n  box-shadow: none;\n  font-size: 15px;\n  padding: 0;\n  margin: 0;\n  height: auto;\n\n  :hover {\n    border: none;\n    background-color: transparent;\n    color: ",
        ";\n  }\n\n  :active {\n    order: none;\n    background-color: transparent;\n    color: ",
        ";\n  }\n\n  :focus {\n    order: none;\n    background-color: transparent;\n    color: ",
        ";\n  }\n\n  :selected {\n    order: none;\n    background-color: transparent;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const HoverableButton = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    className: "ant-btn"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.black;
});

// EXTERNAL MODULE: ../../node_modules/antd/es/tooltip/index.js + 3 modules
var tooltip = __webpack_require__(55003);
;// CONCATENATED MODULE: ../../libs/ui-components/src/lib/common/atoms/Tooltip/index.tsx




const Tooltip = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverableButton, {
            children: props.children
        })
    });
};


/***/ })

}]);